module.exports = __webpack_public_path__ + "img/bring_backward.2be242b0.svg";